// touch-hover.js — FINAL (iOS + Android stable with scroll delay)

(function () {

  let lastPreviewCard = null;
  let holdTimer = null;
  let scrollPreviewTimer = null;
  let isHolding = false;

  let startX = 0;
  let startY = 0;
  let moved = false;

  function isHoverCapable() {
    return window.matchMedia('(hover: hover)').matches;
  }

  function getCard(el) {
    return el && el.closest && (el.closest('.card-wrapper') || el.closest('.card-product'));
  }

  // TOUCH START
  document.addEventListener('touchstart', function (e) {
    if (isHoverCapable()) return;

    const card = getCard(e.target);
    if (!card) return;

    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;

    moved = false;
    isHolding = false;

    clearTimeout(scrollPreviewTimer);

    // clear previous preview
    if (lastPreviewCard && lastPreviewCard !== card) {
      lastPreviewCard.classList.remove('is-touched');
    }

    // HOLD → preview (delay)
    holdTimer = setTimeout(function () {
      if (!moved) {
        card.classList.add('is-touched');
        lastPreviewCard = card;
        isHolding = true;
      }
    }, 220); // 🔧 HOLD delay (you can adjust)

  }, { passive: true });

  // TOUCH MOVE
  document.addEventListener('touchmove', function (e) {
    if (isHoverCapable()) return;

    const card = getCard(e.target);
    if (!card) return;

    const touch = e.touches[0];

    const deltaX = Math.abs(touch.clientX - startX);
    const deltaY = Math.abs(touch.clientY - startY);

    if (deltaX > 10 || deltaY > 10) {
      moved = true;

      clearTimeout(holdTimer);

      // If already holding → keep preview
      if (isHolding) return;

      // 🔥 Scroll preview with delay (NOT instant)
      if (!scrollPreviewTimer) {
        scrollPreviewTimer = setTimeout(() => {
          card.classList.add('is-touched');
          lastPreviewCard = card;
          isHolding = true;
        }, 200); // 🔧 SCROLL delay (you can adjust)
      }
    }

  }, { passive: true });

  // TOUCH END
  document.addEventListener('touchend', function (e) {
    if (isHoverCapable()) return;

    clearTimeout(holdTimer);
    clearTimeout(scrollPreviewTimer);
    scrollPreviewTimer = null;

    const card = getCard(e.target);
    if (!card) return;

    const isButton =
      e.target.closest('button') ||
      e.target.closest('.quick-add') ||
      e.target.closest('form');

    // SCROLL → do nothing
    if (moved && !isHolding) {
      card.classList.remove('is-touched');
      return;
    }

    // HOLD → preview only
    if (isHolding) {
      setTimeout(function () {
        card.classList.remove('is-touched');
        if (lastPreviewCard === card) lastPreviewCard = null;
      }, 200);

      isHolding = false;
      return;
    }

    // TAP → open product (iOS fix)
    card.classList.remove('is-touched');

    if (isButton) {
      // 🔥 iOS FIX: trigger real click without breaking default behavior
      const btn = e.target.closest('button');

      if (btn) {
        const evt = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        btn.dispatchEvent(evt);
      }
      return;
    }


    const link = e.target.closest('a') || card.querySelector('a[href]');
    if (link) {
      window.location.href = link.href;
    }

  }, { passive: true });

})();